import { Permission } from '@server/permissions';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { usePermissions } from './usePermissions';

export const useHasAllPermissions = (permissionArray: Permission[], crmOrgId?: string) => {
  const { hasAllPermissions } = usePermissions();
  const defaultCrmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const effectiveCrmOrgId = crmOrgId ?? defaultCrmOrgId ?? undefined;

  return hasAllPermissions(permissionArray, effectiveCrmOrgId);
};
